import { rotuloUnidade, tryConvertQuantidade } from './unidadeMedida';

/** Quantidade disponível do lote convertida para a unidade da formulação. */
export function disponivelNaUnidadeFormulacao(lote, unidadeFormulacao) {
  const q = Number(lote?.quantidade_disponivel) || 0;
  if (q <= 0) return 0;
  const uLote = rotuloUnidade(lote?.unidade || unidadeFormulacao);
  const uForm = rotuloUnidade(unidadeFormulacao);
  if (uLote.toLowerCase() === uForm.toLowerCase()) return q;
  const equiv = tryConvertQuantidade(q, uLote, uForm);
  return equiv != null && Number.isFinite(equiv) ? equiv : q;
}

/**
 * Monta o plano FEFO: quanto pegar de cada lote para cobrir `quantidadeNecessaria`
 * (já na unidade da formulação). Lotes devem vir ordenados por validade.
 * @returns {{ plano: Array<{ lote: object, quantidade: number }>, faltante: number }}
 */
export function alocarConsumoFEFO(lotes, quantidadeNecessaria, unidadeFormulacao) {
  let restante = Number(quantidadeNecessaria) || 0;
  const plano = [];
  if (!(restante > 0)) return { plano, faltante: 0 };

  for (const lote of lotes || []) {
    if (restante <= 1e-9) break;
    const disp = disponivelNaUnidadeFormulacao(lote, unidadeFormulacao);
    if (disp <= 0) continue;
    const usar = Math.min(disp, restante);
    const q = Math.round(usar * 10000) / 10000;
    if (q <= 0) continue;
    plano.push({ lote, quantidade: q });
    restante -= q;
  }

  const faltante = Math.round(Math.max(0, restante) * 10000) / 10000;
  return { plano, faltante };
}
